// Insights store — fetches the live operational intelligence overview
// from /api/insights/overview and shares it across the AI Insights page
// surface so every sub-component renders against real org data.
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const InsightsContext = createContext({
  data: null,
  loading: true,
  error: null,
  refresh: () => {},
});

export const InsightsProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setError(null);
    try {
      const res = await api.get("/api/insights/overview");
      setData(res.data);
    } catch (e) {
      setError(e?.response?.data?.detail || e?.message || "Failed to load insights");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    // Light auto-refresh every 60s so the live feed stays fresh.
    const t = setInterval(refresh, 60_000);
    return () => clearInterval(t);
  }, [refresh]);

  return (
    <InsightsContext.Provider value={{ data, loading, error, refresh }}>
      {children}
    </InsightsContext.Provider>
  );
};

export const useInsights = () => useContext(InsightsContext);
